module.exports = require("@angular/core");


//////////////////
// WEBPACK FOOTER
// external "@angular/core"
// module id = 0
// module chunks = 0